import { render, staticRenderFns } from "./OctForm.vue?vue&type=template&id=aec3a2e6&scoped=true&"
import script from "./OctForm.vue?vue&type=script&lang=js&"
export * from "./OctForm.vue?vue&type=script&lang=js&"
import style0 from "./OctForm.vue?vue&type=style&index=0&id=aec3a2e6&prod&scoped=true&lang=scss&"
import style1 from "./OctForm.vue?vue&type=style&index=1&id=aec3a2e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec3a2e6",
  null
  
)

export default component.exports